// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'

import OverpaymentsList from 'syft-acp-core/entities/OverpaymentsList'
import PageView from 'syft-acp-core/components/PageView'
import SubNavigationFinance from './SubNavigation'

export const FinanceOverpayments = () => (
  <>
    <SubNavigationFinance />
    <PageView title={['Finance', 'Overpayments']} entityPage>
      <OverpaymentsList />
    </PageView>
  </>
)
